import { z } from 'zod';
import { TenantProfileSchema } from '@kilat/shared';
import { createRepo } from './_base.js';

/**
 * tenants/{tid} doc holds `profile` (TenantProfileSchema) plus other sub-docs
 * (branding, subscription) under nested collections. This repo focuses on the
 * root tenant doc; sub-collections have their own repos.
 *
 * The payout bank account is NOT here. It lived on this document as
 * `payoutBankAccount` until 2026-10-15, and this document is world-readable;
 * it is now `tenants/{tid}/private/payoutBank` — see
 * `tenant-payout-bank-repo.ts`. Zod strips the legacy field if a
 * not-yet-migrated document still carries it.
 */
const TenantRootSchema = z.object({
  // Sprint 118 — `_base.ts` injects `id` from the Firestore doc id before
  // schema parse, so retaining it lets `listSnapshot` callers (e.g. the
  // super-admin tenants page's recent-tenants table) use `t.id` for keys
  // + cross-collection lookups without re-grovelling the Firestore docs.
  id: z.string().min(1).optional(),
  profile: TenantProfileSchema,
});

export const tenantsRepo = createRepo({
  path: 'tenants',
  schema: TenantRootSchema,
  name: 'tenants',
});
